import type { Merchant } from '@/api/types';

/** identity merchants.status (`MerchantStatus` in the contract, generated). */
export type MerchantStatus = Merchant['status'];

/**
 * The lifecycle actions a merchant's status allows, as Identity's MerchantService enforces them: approve from
 * pending or suspended (approving an approved merchant is a no-op, a draft one is 409), suspend only an approved
 * merchant, close anything not closed yet. Permissions are checked separately.
 */
export function merchantActions(status: MerchantStatus): {
    approve: boolean;
    suspend: boolean;
    close: boolean;
} {
    const s = status;
    return {
        approve: s === 'pending' || s === 'suspended',
        suspend: s === 'approved',
        close: s !== 'closed',
    };
}
